const lazySrcAttribute = 'data-lazy-src';
// Атрибут для отложенной загрузки изображения при событиях отличных от прокрутки страницы
const lazySrcRequiredAttribute = 'data-lazy-required';
const lazySrcsetAttribute = 'data-lazy-srcset';

const acceptableOffset = 100;

const setSrcset = ( node ) => {
	node.setAttribute( 'srcset', node.getAttribute( lazySrcsetAttribute ) );
	node.removeAttribute( lazySrcsetAttribute );
};

const loadImage = ( img ) => {
	if ( img.getAttribute( lazySrcAttribute ) )
	{
		const imgRect = img.getBoundingClientRect();
		
		if ( imgRect.y <= (window.innerHeight + acceptableOffset) )
		{
			img.setAttribute( 'src', img.getAttribute( lazySrcAttribute ) );
			img.removeAttribute( lazySrcAttribute );
			
			const picture = img.closest( 'picture' );
			
			if ( picture )
			{
				picture.querySelectorAll( `*[${lazySrcsetAttribute}]` ).forEach( setSrcset );
			}
			else if ( img.getAttribute( lazySrcsetAttribute ) )
			{
				setSrcset( img );
			}
		}
	}
};

const loadLazyImages = () => {
	document.querySelectorAll( `img[${lazySrcAttribute}]:not([${lazySrcRequiredAttribute}])`)
		.forEach( loadImage );
};

const initLazyImages = () => {
	window.addEventListener( 'scroll', loadLazyImages );
	window.addEventListener( 'resize', loadLazyImages );
	
	loadLazyImages();
};

export {
	initLazyImages,
	loadImage,
	lazySrcRequiredAttribute,
};
